// extracted by mini-css-extract-plugin
export default {"form":"TaskForm_form__oKY6X","field":"TaskForm_field__rVj5p"};